import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { TranslatorContext } from '../../context/Translator';
import Swal from 'sweetalert2';
import copy from 'copy-to-clipboard';

export default function TransferenceModalComponent({
  show,
  onHide,
  transferencia,
  onConfirm,
  loading = false,
  cuentaBancaria = null
}) {
  const { t } = useContext(TranslatorContext);
  const [tiempoRestante, setTiempoRestante] = useState(30);
  const [referenciaPago, setReferenciaPago] = useState('');
  const [codigoCopiado, setCodigoCopiado] = useState(false);

  // Timer para contar hacia atrás
  useEffect(() => {
    if (!show || !transferencia) return;

    const timer = setInterval(() => {
      setTiempoRestante(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onHide();
          Swal.fire({
            icon: 'warning',
            title: 'Código expirado',
            text: 'El código de transferencia ha expirado. Por favor, genere uno nuevo.',
          });
          return 0;
        }
        return prev - 1;
      });
    }, 60000);

    return () => clearInterval(timer);
  }, [show, transferencia, onHide]);

  const handleCopiarCodigo = () => {
    copy(transferencia?.trn_codigo || '');
    setCodigoCopiado(true);
    setTimeout(() => setCodigoCopiado(false), 2000);
  };

  const handleConfirm = () => {
   /* if (!referenciaPago.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Referencia requerida',
        text: 'Por favor, ingrese la referencia o número de comprobante de la transferencia.',
      });
      return;
    }*/

    onConfirm(referenciaPago);
  };

  const formatearMoneda = (monto) => {
    if (!monto) return '$0';
    return `$${Number(monto).toLocaleString('es-CL')}`;
  };

  const formatearTiempo = (minutos) => {
    const mins = Math.floor(minutos);
    const secs = Math.floor((minutos % 1) * 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Pagar por Transferencia Bancaria</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {transferencia ? (
          <div className="space-y-4">
            {/* Monto a pagar */}
            <div className="alert alert-info">
              <h5>Monto a Pagar</h5>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span>Total:</span>
                <h4 className="mb-0 text-primary">
                  {formatearMoneda(transferencia.trn_monto)}
                </h4>
              </div>
              {transferencia.trn_multa > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-2 text-muted">
                  <small>Incluye multa por atraso:</small>
                  <small>{formatearMoneda(transferencia.trn_multa)}</small>
                </div>
              )}
            </div>

            {/* Código único */}
            <div className="card border-warning">
              <div className="card-body">
                <h6 className="card-title text-warning">
                  🔑 Código Único (válido por 30 minutos)
                </h6>
                <div className="d-flex gap-2 align-items-center mt-3">
                  <div className="flex-grow-1">
                    <Form.Control
                      type="text"
                      value={transferencia.trn_codigo}
                      readOnly
                      className="font-monospace fw-bold text-center"
                      style={{ fontSize: '1.2em', letterSpacing: '0.1em' }}
                    />
                  </div>
                  <Button
                    variant={codigoCopiado ? 'success' : 'outline-primary'}
                    onClick={handleCopiarCodigo}
                    title="Copiar código"
                  >
                    {codigoCopiado ? '✓ Copiado' : 'Copiar'}
                  </Button>
                </div>
                <small className="text-muted d-block mt-2">
                  ⏱️ Tiempo restante: {formatearTiempo(tiempoRestante)} minutos
                </small>
              </div>
            </div>

            {/* Instrucciones */}
            <Alert variant="light" className="border">
              <Alert.Heading as="h6" className="mb-3">
                📝 Instrucciones de Pago
              </Alert.Heading>
              <ol className="mb-0 small">
                <li>Realice una transferencia bancaria con el monto indicado arriba</li>
                <li>
                  En la referencia o descripción del pago, <strong>COPIE EL CÓDIGO ÚNICO</strong>
                </li>
                <li>
                  Envíe un email a <code>pagos@estugira.com</code> con:
                  <ul className="mt-2 mb-0">
                    <li>El código único de pago</li>
                    <li>Comprobante de la transferencia (captura de pantalla o PDF)</li>
                    <li>Sus datos de identificación</li>
                    <li><b>Importante:</b> Una vez hecha la transferencia, presione el botón "Transferencia Realizada" en esta ventana, para poder procesar su pago.</li>
                  </ul>
                </li>
                <li>Nuestro equipo verificará el pago dentro de 72 horas aproximadamente</li>
              </ol>
            </Alert>

            {cuentaBancaria && (
              <div className="card border-secondary">
                <div className="card-body">
                  <h6 className="card-title">Datos de la Cuenta Bancaria</h6>
                  <div className="small">
                    <div className="mb-2">
                      <strong>Banco:</strong> {cuentaBancaria.banco}
                    </div>
                    <div className="mb-2">
                      <strong>Tipo Cuenta:</strong> {cuentaBancaria.tipoCuenta}
                    </div>
                    <div className="mb-2">
                      <strong>Número Cuenta:</strong> <code>{cuentaBancaria.numero}</code>
                    </div>
                    <div className="mb-2">
                      <strong>RUT:</strong> {cuentaBancaria.rut}
                    </div>
                    <div>
                      <strong>Titular:</strong> {cuentaBancaria.titular}
                    </div>
                    <div className="mb-2">
                      <strong>Correo Electrónico:</strong> pagos@estugira.com
                    </div>
                  </div>
                </div>
              </div>
            )}

    
           
          </div>
        ) : (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cerrar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
         
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Registrando...
            </>
          ) : (
            'Tranferencia Realizada'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
